export const COMMERCIAL_IMPULSES = [
    { id: 'auto', label: 'Modo Automático', icon: '📡', description: 'Sistema Circadiano Aura (Sigue el ritmo del día).', hasPlaylist: true },
    { id: 'morning', label: 'Mañanas Aura', icon: '☀️', description: 'Luz y armonía para empezar el día con brillo.', hasPlaylist: true },
    { id: 'active', label: 'Energía Vital Aura', icon: '⚡', description: 'Ritmos vibrantes para activar el ambiente.', hasPlaylist: true },
    { id: 'aperitivo', label: 'Hora del Vermut', icon: '🍹', description: 'Ambiente fresco y alegre para el mediodía.', hasPlaylist: true },
    { id: 'after-lunch', label: 'Sobremesa Premium', icon: '☕', description: 'El acompañamiento ideal para café y copas.', hasPlaylist: true },
    { id: 'aura_flamenca', label: 'Esencia Flamenca', icon: '💃', description: 'Elegancia y raíz para momentos con duende.', hasPlaylist: true },
    { id: 'marbella', label: 'Beach Club Vibes', icon: '🏖️', description: 'Sonido elegante, sofisticado y veraniego.', hasPlaylist: true },
    { id: 'midnight', label: 'Noche Lounge', icon: '🌙', description: 'Atmósfera íntima para las últimas copas.', hasPlaylist: true },
    { id: 'sunset', label: 'Atardecer Aura', icon: '🌅', description: 'Transición perfecta del día a la noche.', hasPlaylist: true },
    { id: 'musicas_del_mundo', label: 'Expedición Global', icon: '🌍', description: 'Un viaje sonoro exótico y sofisticado.', hasPlaylist: true },
    { id: 'night_lounge', label: 'Terrazas Lounge', icon: '🍸', description: 'Chill-out envolvente para el relax total.', hasPlaylist: true },
    { id: 'nocturno', label: 'Gala Nocturna', icon: '✨', description: 'Máxima sofisticación para el servicio de cena.', hasPlaylist: true },
    { id: 'urban-tribal', label: 'Ritmo Urbano', icon: '🏙️', description: 'Sonido contemporáneo y cosmopolita.', hasPlaylist: true },
    { id: 'meditation', label: 'Aura Meditation', icon: '🧘', description: 'Paz profunda, frecuencias curativas y calma absoluta.', hasPlaylist: true },
    { id: 'live', label: 'Aura Live', icon: '🔴', description: 'Emisión en directo desde el servidor central de Aura.', hasPlaylist: true },
    { id: 'favorites', label: 'Favoritos', icon: '❤️', description: 'Tus canciones seleccionadas.', hasPlaylist: true },
  ];

export const DEMO_SECTORS = [
    { 
        id: 'real', 
        label: 'Aura Real', 
        url: 'https://auradisplay.es/el-jamon-demo',
        isReal: true
    },
    { 
        id: 'rest', 
        label: 'Restauración', 
        url: 'https://auradisplay.es/restaurante-demo',
        data: {
            establishmentName: 'El Jardín del Gourmet',
            location: 'Madrid, ES',
            contents: [{ url: 'https://images.unsplash.com/photo-1559339352-11d035aa65de?auto=format&fit=crop&q=80&w=1200', name: 'Plato estrella' }],
            quotes: [{ text: 'Experiencias que se saborean y se recuerdan.', subtext: 'Cocina de Autor - Menú Degustación' }],
            tickers: [{ text: 'Reserva tu mesa para esta noche • Consultar carta de vinos • Especialidad del día: Merluza en salsa verde' }]
        }
    },
    { 
        id: 'gym', 
        label: 'Gimnasios', 
        url: 'https://auradisplay.es/gym-demo',
        data: {
            establishmentName: 'Zenith Performance',
            location: 'Barcelona, ES',
            contents: [{ url: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&q=80&w=1200', name: 'Gimnasio' }],
            quotes: [{ text: 'Tu disciplina transforma tu realidad.', subtext: 'Entrenamiento Funcional & HIIT' }],
            tickers: [{ text: 'Clase de Yoga a las 19:00 • Próximo taller de nutrición el 20/05 • ¡Inscripciones abiertas!' }]
        }
    },
    { 
        id: 'joyeria', 
        label: 'Joyeria', 
        url: 'https://auradisplay.es/joyeria-demo',
        data: {
            establishmentName: 'Diamante & Seda',
            location: 'Valencia, ES',
            contents: [{ url: 'https://images.unsplash.com/photo-1515562141207-7a88fb744047?auto=format&fit=crop&q=80&w=1200', name: 'Joyas' }],
            quotes: [{ text: 'Elegancia atemporal en cada detalle.', subtext: 'Alta Joyería Artesanal' }],
            tickers: [{ text: 'Nueva colección de compromiso • Servicio de tasación gratuito • Visítanos en nuestra boutique' }]
        }
    },
    { 
        id: 'hotel', 
        label: 'Hoteles', 
        url: 'https://auradisplay.es/hotel-demo',
        data: {
            establishmentName: 'Palacio del Retiro Suites',
            location: 'Sevilla, ES',
            contents: [{ url: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&q=80&w=1200', name: 'Hotel' }],
            quotes: [{ text: 'Donde el descanso encuentra el máximo lujo.', subtext: 'Suite Ejecutiva con vistas' }],
            tickers: [{ text: 'Check-in a partir de las 15:00 • Desayuno buffet disponible • Spa abierto hasta las 22:00' }]
        }
    },
    { 
        id: 'moda', 
        label: 'Moda', 
        url: 'https://auradisplay.es/moda-demo',
        data: {
            establishmentName: 'Vogue & Trend Boutique',
            location: 'Bilbao, ES',
            contents: [{ url: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&q=80&w=1200', name: 'Moda' }],
            quotes: [{ text: 'Define tu estilo, marca tendencia.', subtext: 'Nueva Colección Primavera/Verano' }],
            tickers: [{ text: 'Descuento del 20% en prendas seleccionadas • Nueva llegada de accesorios • Asesoramiento personalizado' }]
        }
    },
];


  export const DEFAULT_CIRCADIAN = [
    { start: 0, end: 1, folder: 'meditation' },
    { start: 1, end: 2, folder: 'midnight' },
    { start: 2, end: 3, folder: 'meditation' },
    { start: 3, end: 4, folder: 'midnight' },
    { start: 4, end: 5, folder: 'meditation' },
    { start: 5, end: 6, folder: 'midnight' },
    { start: 6, end: 7, folder: 'meditation' },
    { start: 7, end: 8, folder: 'midnight' },
    { start: 8, end: 11, folder: 'morning' },
    { start: 11, end: 12, folder: 'aperitivo' },
    { start: 12, end: 17, folder: 'active' },
    { start: 17, end: 20, folder: 'after-lunch' }, 
    { start: 20, end: 24, folder: 'nocturno' }
  ];
